import { t } from "ttag";

import { BrandedLogo } from "agavepulse/branding/BrandedLogo";
import { EditableText } from "metabase/common/components/EditableText";
import { DASHBOARD_NAME_MAX_LENGTH } from "metabase/common/utils/dashboard";
import { useTranslateContent } from "metabase/content-translation/hooks";
import { useDashboardContext } from "metabase/dashboard/context";
import { useDashboardTitle } from "metabase/dashboard/hooks/use-dashboard-title";
import { Flex } from "metabase/ui";

export const DashboardTitle = ({ className }: { className?: string }) => {
  const [title, setTitle] = useDashboardTitle();
  const { dashboard, isEditableDashboard } = useDashboardContext();
  const tc = useTranslateContent();

  if (!dashboard) {
    return null;
  }

  return (
    // AgavePulse: the client's logo sits beside the title so it is the first thing a
    // client sees on their shared link. BrandedLogo renders nothing unless the dashboard
    // has a logoUrl, so unbranded dashboards are visually unchanged.
    <Flex align="center" gap="sm" className={className}>
      <BrandedLogo height={28} />
      <EditableText
        key={title}
        initialValue={tc(title)}
        placeholder={t`Add title`}
        isDisabled={!isEditableDashboard}
        data-testid="dashboard-name-heading"
        onChange={setTitle}
        maxLength={DASHBOARD_NAME_MAX_LENGTH}
      />
    </Flex>
  );
};
